import { Directive, ElementRef, Renderer2, HostListener, AfterViewInit, DoCheck } from '@angular/core';

@Directive({
  selector: '[appStyledInput]',
  standalone: true
})
export class StyledInputDirective implements AfterViewInit, DoCheck {
  private pseudoEl: HTMLElement | null = null;
  private lastCheckedState: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.createPseudoElement();
    this.syncState();
  }

  ngDoCheck() {
    // Detect programmatic changes (e.g. ngModel or [checked] binding changes)
    if (this.el.nativeElement.checked !== this.lastCheckedState) {
      this.syncState();
    }
  }

  private createPseudoElement() {
    const inputType = this.el.nativeElement.type;

    this.pseudoEl = this.renderer.createElement('span');
    this.renderer.addClass(this.pseudoEl, 'pseudo' + inputType);

    // FIX: Listen for clicks on the span and forward them to the input
    this.renderer.listen(this.pseudoEl, 'click', (event) => {
      event.stopPropagation(); // Stops SPAN event
      event.preventDefault();
      this.el.nativeElement.click(); // Fires INPUT event (which bubbles!)
    });

    // Insert the span *after* the input
    const parent = this.renderer.parentNode(this.el.nativeElement);
    const nextSibling = this.renderer.nextSibling(this.el.nativeElement);
    this.renderer.insertBefore(parent, this.pseudoEl, nextSibling);
  }

  @HostListener('change')
  onChange() {
    this.syncState();
  }

  @HostListener('focus')
  onFocus() {
    if (this.pseudoEl) this.renderer.addClass(this.pseudoEl, 'focus');
  }

  @HostListener('blur')
  onBlur() {
    if (this.pseudoEl) this.renderer.removeClass(this.pseudoEl, 'focus');
  }

  @HostListener('click', ['$event'])
  onInputClick(event: Event) {
    // This stops the click event from reaching the <li> or dropdown container.
    // It prevents the parent from toggling the value back to false.
    event.stopPropagation();
  }

  private syncState() {
    if (!this.pseudoEl) return;

    const isChecked = this.el.nativeElement.checked;
    this.lastCheckedState = isChecked;

    if (isChecked) {
      this.renderer.addClass(this.pseudoEl, 'checked');
      this.renderer.removeAttribute(this.pseudoEl, 'aria-hidden');
    } else {
      this.renderer.removeClass(this.pseudoEl, 'checked');
      this.renderer.setAttribute(this.pseudoEl, 'aria-hidden', 'true');
    }
  }
}
